/** Action Types */
const actionTypes = {
  /* Org actionTypes*/
  SET_ORG: "SET_ORG",
  SET_ORGS: "SET_ORGS",
  CLEAR_ORG: "CLEAR_ORG",
  /** Maintenance */
  SET_GROUPS: "SET_GROUPS",
  SET_GROUP: "SET_GROUP",
  SET_ITEMS: "SET_ITEMS",
  SET_ITEM: "SET_ITEM",
  /**Work */
  SET_WORK_INSTRUCTION: "SET_WORK_INSTRUCTION",
  /* Work Events */
  SET_WORK_EVENT_CUSTOMER: "SET_WORK_EVENT_CUSTOMER",
  SET_WORK_EVENT_PLACES: "SET_WORK_EVENT_PLACES",
  CLEAR_PLACES: "CLEAR_PLACES",
  CLEAR_CUST_AND_PLACES: "CLEAR_CUST_AND_PLACES",
};

export default actionTypes;
